import React, { useState, useEffect } from 'react';
import { Table, Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
import { fetchAdminApi } from '../../../../services/api';
import constants from '../../../../constants/constants';
import { getCustomisedBreadcrumbs } from '../../../../functions/functions';

function MediaList({
	apiEndpoint,
	column,
	pageTitle,
	linkPrefix,
	crumbLabel,
}) {
	const [chapterData, setChapterData] = useState([]);

	const newCrumb = [
		<Link key={0} to={linkPrefix} className="font-semibold !text-black">
			{crumbLabel}
		</Link>,
	];

	useEffect(() => {
		fetchMediaData();
	}, []);

	const fetchMediaData = () => {
		fetchAdminApi(apiEndpoint, 'get').then((res) => {
			if (res?.data && res?.data.length > 0) {
				setChapterData(res.data);
			} else {
				setChapterData([]);
			}
		});
	};

	return (
		<Row>
			<Col span={24}>
				<div className="p-4 min-h-screen bg-gray-100">
					<Breadcrumb
						items={getCustomisedBreadcrumbs(
							constants.flashCardpageCrumbs,
							newCrumb
						)}
						className="bg-neutral-100 shadow-md p-3"
					/>
					<Table
						bordered
						columns={column}
						dataSource={chapterData}
						pagination={false}
						locale={{ emptyText: constants.emptyTableText }}
						tableLayout="auto"
						title={() => (
							<div className="font-bold tracking-wide text-lg pl-3 flashTableTitle">
								{pageTitle}
							</div>
						)}
						className="mt-4"
					/>
				</div>
			</Col>
		</Row>
	);
}

export default MediaList;